/* eslint-disable no-restricted-globals */
const HOSTNAME = location.hostname.toLocaleLowerCase();
const isProduction = HOSTNAME.includes('inventory.centauro.net') || HOSTNAME.includes('inventory.grupocentauro.com');

export default isProduction
	? 'http://inventory-api.grupocentauro.com/api'
	: 'http://inventory-api-test.grupocentauro.com/api';
